export default __webpack_public_path__ + "static/media/dark_open_26.446392d9.svg";